import { PersonalDetailsFormNew_MX } from './mixed';

export const PersonalDetailsFormNew = {
  SPB: PersonalDetailsFormNew_MX,
};
